<template>
  <div class="card">
    <h5>Ingrese el archivo a procesar.</h5>
    <Message :severity="information" :key="data" :closable="false">
      Seleccione el archivo que desea procesar, este debe contener las columnas
      con los mismos nombre de los campos de la plantillas, más 2 columnas
      requeridas para el envio , "email" y "subject"
    </Message>

    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-3">
        <label for="plantilla">Plantilla</label>
        <Dropdown
          id="plantilla"
          v-model="plantilla"
          :options="plantillas"
          optionLabel="name"
          placeholder="Select Plantilla"
        ></Dropdown>
      </div>
      <div class="p-field p-col-12 p-md-3">
        <label for="file">Archivo csv</label>

        <!-- <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/> -->
        <FileUpload
          mode="basic"
          name="file"
          id="file"
          ref="file"
          accept="csv"
          label="Subir"
          choose-label="Archivo"
          :multiple="false"
          :maxFileSize="1000000"
          @change="handleFileUpload()"
        />
      </div>
    </div>

    <div class="p-d-flex p-jc-center">
      <div class="p-mr-2">
        <Button v-on:click="submitFile()" label="Subir" />
      </div>
      <router-link to="/csv">
        <div class="p-mr-2"><Button type="button" label="Cancel" /></div>
      </router-link>
    </div>

    <div class="p-col-12 p-lg-4 contacts" v-if="cantidad > 0">
      <Panel header="Resultados de la importación">
        <ul>
          <li>
            <button class="p-link">
              <span class="name">Registros</span>
              <span class="email">{{ this.cantidad }}</span>
            </button>
          </li>
          <li>
            <button class="p-link">
              <span class="name">Campos</span>
              <span class="email">{{ this.campos.length }}</span>
            </button>
          </li>
        </ul>

        <div>
          <router-link to="/csv">
            <Button label="Procesar" style="width: 10rem" />
          </router-link>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost } from '../../helpers/rest-api';

export default {
  data() {
    return {
      plantillas: [],
      file: '',
      cantidad: 0,
      campos: [],
      plantilla: 88,
      processId: '',
    };
  },
  mounted() {
    this.getAll();
  },

  methods: {
    getAll() {
      apiGet('plantilla').then((response) => {
        this.plantillas = response.data;
      });
    },
    handleFileUpload() {
      console.log('Cargando file ');
      this.file = this.$refs.file.files[0];
    },
    submitFile() {
      let formData = new FormData();
      /*
            for( var i = 0; i < this.files.length; i++ ){
                let file = this.files[i];

                formData.append('file', this.file, file.name);
            }
            */

      formData.append('file', this.file);
      formData.append('plantillaId', this.plantilla.id);

      apiPost('csv', formData, {
        headers: { 'content-type': 'multipart/form-data' },
      }).then((response) => {
        const { fields, rowCount, id } = response.data;

        this.cantidad = rowCount;
        this.campos = fields;
        this.processId = id;
      });
    },
  },
};
</script>
